import {
  Component, Input, Output, EventEmitter, OnInit,
  AfterViewInit, AfterViewChecked, ElementRef
} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { KEY_CONFIG } from 'lib/ng2-sapmp/src/config/key-config';
import { AuthenticationService } from 'lib/ng2-sapmp/src/providers/authentication.service';
import { Router } from '@angular/router';

@Component({
  selector: 'login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']

})
export class LoginModalComponent implements OnInit {
  showLoginModal: boolean = false;
  focusabbleElements: any;

  constructor(private el: ElementRef,
    private router: Router,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    console.log("login-modal");
  }

  closeOverviewModal() {
    this.authenticationService.setLoginModalStatus(false);
    const loginSuccessUrl = this.authenticationService.getLoginSuccessUrl();
    const navigateTo = loginSuccessUrl ? loginSuccessUrl : 'home';
    if (this.router.url === '/') {
      this.router.navigate([]);
    }
  }

  //TODO this is where you set the domain
  loginDirect(portal) {
    this.authenticationService.setLoginModalStatus(false);
    this.authenticationService.loginDirect(portal);
  }

  handleKeydown(event) {
    const focussedEl = event.target;
    // if (event.keyCode === KEY_CONFIG.escapeKey) {
    //   // this.btnAction();
    //   return;
    // }
    if (event.keyCode === KEY_CONFIG.tabKey) {
      if (focussedEl === this.focusabbleElements[this.focusabbleElements.length - 1]) {
        event.preventDefault();
        this.focusabbleElements[0].focus();
      }
    }
  }

  loadFocustelements() {
    if (!this.focusabbleElements) {
      const focusableEls = this.el.nativeElement.
        querySelectorAll('a[href], area[href],' +
        ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      this.focusabbleElements[0].focus();
    }
  }

}
